/**
 * @author WYX
 * @date 2019/12/26
 * @Description: 稿件标签指令模块
 */
angular.module('mediaSelectorModule').directive('mediaSelectItem', [
    '$stateParams',
    'messagePublishService',
    'mrApiService',
    '$state',
    'modalDialog',
    'localStorageService',
    '$modal',
    function($stateParams, messagePublishService, mrApiService, $state, modalDialog, localStorageService, $modal) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './components/util/trsMediaSelector/derective/trsMediaItem/mediaSelectItem_tpl.html',
            replace: true,
            transclude: true,
            link: function($scope, $element, $attr) {
                initStatus();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {
                        // 是否选中
                        isCheck: false,
                        // 是否展示工具栏
                        listIndex: Number($attr.index),
                    };
                }



                /**
                 * [changeCheck description]改变选中状态
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.changeCheck = function() {
                    if ($scope.item.resourcestatus == -10) {
                        return;
                    }
                    $scope.status.isCheck = !$scope.status.isCheck;
                    if ($scope.status.isCheck) {
                        $scope.selectedArray.push($scope.items[$attr.index]);
                    } else {
                        $scope.selectedArray.forEach(function(element, index) {
                            if (element.relationid === $scope.items[$attr.index].relationid) {
                                $scope.selectedArray.splice(index, 1);
                            }
                        });
                    }
                };

                $scope.openFolder = function() {
                    // 缓存当前海贝检索参数
                    localStorageService.set('materialSearchParams', $scope.basicalStatus.searchParams);
                    $scope.basicalStatus.currentFolderId = $scope.item.relationid;
                    $scope.basicalStatus.isInFolder = true;
                    $scope.getFolderMaterial();
                };
            },
        };
    },
]);
